import { useEffect } from 'react';
import { preserveUtmParams } from '@/shared/services/analytics/utmNavigation';

const UtmNavigationPreserver = () : null => {
    useEffect(() => {
        const preserveAnchorUtm = (event : MouseEvent) => {
            if (!(event.target instanceof Element)) {
                return;
            }

            const anchor = event.target.closest('a');
            const href = anchor?.getAttribute('href');

            if (!anchor || !href || anchor.hasAttribute('download')) {
                return;
            }

            const target = preserveUtmParams(href, window.location.href);

            if (target !== href) {
                anchor.setAttribute('href', target);
            }
        };

        document.addEventListener('click', preserveAnchorUtm, true);

        return () => document.removeEventListener('click', preserveAnchorUtm, true);
    }, []);

    return null;
};

export default UtmNavigationPreserver;
